import { render, staticRenderFns } from "./optionmenu.vue?vue&type=template&id=21bcdc63&"
import script from "./optionmenu.vue?vue&type=script&lang=js&"
export * from "./optionmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports